export default function IconHeartOutlined({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12.0547 6.32882C11.2012 4.91794 9.61012 4.01001 7.86512 4.01001C5.19073 4.01001 3 6.19137 3 8.90306C3 10.2239 3.5216 11.4146 4.35616 12.2952L11.5732 19.5797L11.9905 20L12.4078 19.5797L19.5016 12.4253C20.4215 11.5347 21 10.2839 21 8.89306C21 6.17136 18.8093 4 16.1349 4C14.3804 4 12.9082 4.92795 12.0547 6.32882Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
